
import axios from 'axios'
import config from "@/api/config";
import httpHelper from "@/helpers/http_helper"

// const serverUrl = window.location.origin
axios.defaults.baseURL = config.baseUrl.dev
const serverUrl = config.baseUrl.dev
if(serverUrl.indexOf("-webapp") != -1){
  axios.defaults.baseURL = serverUrl.replace("-webapp","")
}
axios.defaults.timeout = 10000

// http request 拦截器
axios.interceptors.request.use(
  config => {
    // 设置 header 的 access token
    if (process.env.VUE_APP_BASIC_AUTH) {
      config.headers.common['Authorization'] = process.env.VUE_APP_BASIC_AUTH
    }
    //   httpHelper.showLoading() // 请求前，显示加载中

    return config
  },
  error => {
    return Promise.reject(error)
  }
)
// http response 拦截器
axios.interceptors.response.use(
  // 正常响应，状态码 2xx
  response => {
     console.log(response.data)
    // Do something with response data
    return response
  },
  // 异常状态，如 4xx, 5xx
  error => {
    if (error.code === 'ECONNABORTED') {
      // 超时错误
      if (error.message.includes('timeout')) {
        httpHelper.showToast('请求超时，请检查网络连接')
      }
    } else if (error.message === 'Network Error') {
      // 网络连接错误
      httpHelper.showToast('网络连接失败，请检查网络设置')
    } else if (error.code === 'ERR_NETWORK') {
      // 网络不可达
      httpHelper.showToast('网络不可用，请检查网络连接')
    } else if (error.code === 'ERR_INTERNET_DISCONNECTED') {
      // 断网
      httpHelper.showToast('网络已断开，请检查网络连接')
    }

    // Do something with response error
    if (error.response) {
      const code = error.response.status
      const  errorHandle =  httpHelper.handleError(code,error);
      if( errorHandle !== null){
       console.log(errorHandle)
      }
    }
    return Promise.reject(error)
  }
)

export default axios